<div class="container">
  <mat-form-field class="example-form-field">
    <mat-label>{{label}}</mat-label>
    <mat-select [value]="displayValue" (selectionChange)="onSelectionChange($event.value)" [disabled]="disabled">
      <input placeholder="Search..." matInput type="text" (keyup)="onKey($event)" class="example-input">
      <mat-option [value]="''"></mat-option>
      @for (item of selectedOptionList; track item) {
        <mat-option [value]="item">
          {{ item }}
        </mat-option>
      }
    </mat-select>
    @if (control?.hasError('required')) {
      <mat-error>Campo obrigatório</mat-error>
    }
  </mat-form-field>
</div>